module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "olst-range-component olst-field-label-subtitle",
    domProps: {
      "textContent": _vm._s(_vm.rangeHumanized)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c76216a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/texts/RangeMinMaxComponent.vue
// module id = 341
// module chunks = 1